
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component({})
    export default class ServiceOS extends Vue {
        // @ts-ignore
        @Prop({required: false, default: true}) public readonly windows!: boolean;
        // @ts-ignore
        @Prop({required: false, default: true}) public readonly macos!: boolean;
    }
